import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { StationDialogModel } from '../../models/station-dialog.model';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'station-dialog',
  imports: [
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './station-dialog.component.html',
  styleUrl: './station-dialog.component.scss',
})
export class StationDialogComponent {
  stationName = new FormControl('');
  
  constructor(
    public dialogRef: MatDialogRef<StationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: StationDialogModel,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    //populate station name on edit
    this.stationName.setValue(this.dialogData.inputValue);
  }

  onCancel() {
    this.dialogRef.close();
  }

  onClose() {
    this.dialogRef.close(this.stationName.value);
  }
}
